export default __webpack_public_path__ + "static/media/480_portfolio04-nl-mobile.26b972e3.png";